/**
 * Dealer overrides for "Citas de servicio", keyed by the URL slug used in
 * /citas-de-servicio/agendar/:concesionaria.
 * contactEmails replaces the emails read from Octagon "contactos".
 * While contactEmails is empty, the Octagon emails are used.
 */
const CITAS_SERVICIO_DEALER_OVERRIDES = {
  "2051-san-jose-chiapa": {
    dealerNumber: 2051,
    contactEmails: ["recepcion@audiservice.com.mx"],
  },
};

export default CITAS_SERVICIO_DEALER_OVERRIDES;
